import { memo } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/design-system/Atoms";
import React from "react";

type TabButtonProps = {
  iconSrc: string;
  label: string;
  badgeCount?: number | React.ReactNode;
  href?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
  isActive?: boolean;
};

export const TabButton = memo<TabButtonProps>(({
  iconSrc,
  label,
  badgeCount,
  href,
  onClick,
  type = "button",
  disabled = false,
  className = "",
  isActive = false,
}) => {
  const activeBgClass = isActive ? "bg-[#68758f]" : "";

  const buttonContent = (
    <Button
      variant="tabButton"
      size="xl"
      className={`
                !w-full transition-colors duration-150 ease-in-out
                ${className} ${activeBgClass}
                ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
            `}
      type={type}
      onClick={onClick}
      disabled={disabled}
      role="tab"
      aria-selected={isActive}
    >
      {iconSrc && iconSrc.trim() !== "" && <img src={iconSrc} alt="" />}

      {label}

      {React.isValidElement(badgeCount) ? (
        badgeCount
      ) : typeof badgeCount === "number" ? (
        <span className="ml-auto inline-block rounded-full bg-[var(--color-green-100)] text-black text-xs font-bold px-2 py-1">
          {badgeCount}
        </span>
      ) : (
        <span className="ml-auto" />
      )} 
    </Button>
  );

  return href ? <Link to={href}>{buttonContent}</Link> : buttonContent;
});

TabButton.displayName = "TabButton";